import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c7e8696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "layout-list" }
const _hoisted_3 = { class: "left-box" }
const _hoisted_4 = { class: "black title" }
const _hoisted_5 = { class: "grey" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "icon-wrap" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey desc" }, "预览", -1))

import { onMounted, ref, reactive } from 'vue'
import { getMaterialList } from '@/apis/projectDetail'
import { useRouter } from 'vue-router'
import _lodash from '@/utils/lodashUtil'
import vViews from '@/components/vViews.vue'
import { ImagePreview, Toast } from 'vant'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const state = reactive({
  page: 1,
  fileList: [],
  isShow: false,
  showDatas: {},
  isShowType: '',
  suffixName: ''
})

const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const project_id = ref(0)

const downloadExcel = async item => {
  state.suffixName = item.file.substring(item.file.lastIndexOf('.') + 1)
  if (state.suffixName == 'jpg' || state.suffixName == 'png' || state.suffixName == 'gif') {
    ImagePreview([item.file])
    return false
  }

  if (state.suffixName == 'pdf') {
    console.log('pdf')
    window.open(item.file)
    return false
  }

  const a = document.createElement('a')
  a.href = item.file
  a.download = item.file_name
  a.click()
  URL.revokeObjectURL(a.href) // 释放URL 对象
}

const get_material_List = async () => {
  let data = {
    project_id: project_id.value,
    page: state.page,
    page_size: 10
  }
  const res = await getMaterialList(data)
  if (res.code === 200) {
    finished.value = false
    if (refreshing.value) {
      state.fileList = []
      refreshing.value = false
    }
    state.page += 1
    state.fileList = _lodash.uniq(_lodash.concat(state.fileList, res.data.data))
    loading.value = false
    if (state.page > res.data.last_page) {
      // 已到最后一页
      finished.value = true
    }
    console.log(state.fileList)
  }
}
const onRefresh = () => {
  // 清空列表数据
  finished.value = false
  state.page = 1
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  get_material_List()
}

onMounted(() => {
  project_id.value = Number(router.currentRoute.value.query.project_id)
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          onLoad: get_material_List
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).fileList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row row-layout-box",
                  key: item
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.file_name), 1),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(item.created_at), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "right-box",
                    onClick: ($event: any) => (downloadExcel(item))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_van_icon, {
                        class: "icon",
                        name: "back-top"
                      })
                    ]),
                    _hoisted_8
                  ], 8, _hoisted_6)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})